/* import __COLOCATED_TEMPLATE__ from './feature-statuses-loading.hbs.js'; */
import FeatureGateBase from './feature-gate-base';
export default class FeatureStatusesLoading extends FeatureGateBase {
  /**
   * This is true on the initial load. When refetching, it will be false.
   */
  get showContent() {
    return this.isLoading;
  }
}